<template>
<div class="container-fluid">
    <div class="row">
        <div class="col-12">                    
            <h1 data-test="pageTitle">Duplicate Records Manager</h1>

            <div class="card">
                <div class="card-header"><strong>Merging Records</strong></div>
                <div class="card-body">
                <p>Potential duplicate physicians (based on name) are grouped in rows. Click on two records, then select the related items to include in the merge. Click the arrow to change the merge direction if desired.</p>
                <ul class="mb-0">
                    <li>If 3 or more records are present for one physician, merge the first pair to make the next record visible.</li>
                    <li>Merging will not overwrite any existing attributes (e.g. NPI number, email address, EMR ID) present in the destination record.</li><li>Empty attributes in the destination record will be replaced with data from the merged record if present.</li>
                    <li>Unchecked items will not be merged and will be permanently deleted.</li> 
                </ul>
                </div>
            </div>
        </div>
    </div>

    <div v-if="!data_loaded" class="row mt-4">
        <div class="col-12">
            <img class="center-me" src="/images/loading-color.svg">
        </div>
    </div>

    <template v-else>
        <div class="row">
            <div class="col-12">
                <ul class="pagination">
                    <li v-for="alpha_group, key in duplicates" class="page-item"><a :href="'#' + key" class="page-link">{{ key }}</a></li>
                </ul>
            </div>
        </div>

        <div v-for="alpha_group, key in duplicates" class="row">
            <div class="col-1">
                <a :name="key"></a>
                <h1>{{ key }}</h1>
            </div>

            <div class="col-11 mb-4">
                <div v-for="physician_group, key in alpha_group" class="mb-3 align-items-center">
                    <physician-duplicate-group
                        :physician_group="physician_group"
                        @physicians-merged="removeDuplicateGroup($event)"
                    />
                </div>
            </div>
        </div>
    </template>

</div>
</template>

<script>

    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import PhysicianDuplicateGroup from '../../components/PhysicianDuplicateGroup'

	export default {
        mixins: [BreadcrumbsManager],

        components: {
            PhysicianDuplicateGroup,
        },

		data() {
			return {
                data_loaded: false,
				duplicates: {},
			}
		},

        created() {
            this.fetchDuplicates(); 
        },

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Physicians', to: { name: 'physicians.list' } },
                { text: 'Duplicate Finder', to: { name: 'physicians.tools.duplicates' } },
            ]); 
        },

		methods: {
            fetchDuplicates() {
                axios.get(`/api/physicians/duplicates`).then(({data}) => {
                    this.duplicates = data;
                    this.data_loaded = true;
                });   
            },
		},

	}

</script>